import React, { useEffect } from 'react';
import {
  Button,
  LoadingButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import { IModalBasicProps } from '../../../models/common/modal';
import { IPaymentCardCommonData } from '../../../models/common/payments';
import { getCardImagePath } from '../../../utils/credit-cards';
import { track, setOverlayEvent } from '../../../utils/analytics';

const ConfirmHDWalletRemovalSection = ({
  card,
}: {
  card: IPaymentCardCommonData;
}) => {
  const {
    cardBrand,
    cardType,
    cardNumberLast4,
    cardExpiryMonth,
    cardExpiryYear,
  } = card;
  return (
    <>
      <div className="sui-flex sui-flex-wrap sui-mb-6 sui-items-center">
        <img
          width={50}
          height="auto"
          className="sui-inline-block sui-mr-4"
          src={getCardImagePath(cardBrand, cardType)}
          alt="Credit card logo"
        />
        <div className="sui-mr-4">
          <Typography variant="body-lg" color="subtle">
            ****{cardNumberLast4}
          </Typography>
        </div>
        {cardExpiryMonth && cardExpiryYear && (
          <Typography variant="body-lg" color="subtle">
            {`Exp ${cardExpiryMonth}/${cardExpiryYear.slice(-2)}`}
          </Typography>
        )}
      </div>
      <div className="sui-mb-6">
        <Typography>
          Removing HD Pass authorization will stop in-store purchases with this
          card using HD Pass.
        </Typography>
      </div>
    </>
  );
};

export interface IRemoveHDWalletProps {
  card: IPaymentCardCommonData;
  onConfirmRemove: () => void;
  isLoading: boolean;
}

export const RemoveHDWalletModal = ({
  card,
  hideModal,
  onConfirmRemove,
  isLoading,
}: IRemoveHDWalletProps & IModalBasicProps) => {
  useEffect(() => {
    setOverlayEvent('hdpass remove card');
  }, []);

  const onClickNoButton = () => {
    track('home-depot-wallet.actions.remove-hd-pass-button-click', {
      buttonType: 'no',
    });
    hideModal();
  };
  const onClickYesButton = () => {
    track('home-depot-wallet.actions.remove-hd-pass-button-click', {
      buttonType: 'yes remove this card',
    });
    onConfirmRemove();
  };
  return (
    <>
      <ModalHeader onClose={onClickNoButton}>
        Do You Want To Remove HD Pass Authorization For This Credit Card?
      </ModalHeader>
      <ModalBody>
        <ConfirmHDWalletRemovalSection card={card} />
      </ModalBody>
      <ModalFooter>
        <div className="sui-flex sui-whitespace-nowrap sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row">
          <Button variant="secondary" fullWidth onClick={onClickNoButton}>
            No
          </Button>
          <LoadingButton
            variant="primary"
            loading={isLoading}
            fullWidth
            onClick={onClickYesButton}
            data-testid="stop-auth-this-cards-btn"
          >
            Yes, Remove for This Card
          </LoadingButton>
        </div>
      </ModalFooter>
    </>
  );
};

RemoveHDWalletModal.displayName = 'RemoveHDWalletModal';
